import { Outlet, useNavigate } from "react-router-dom";
import { useEffect } from "react";
import useHasAccess from "../hooks/useHasAccess";

interface HasAccessRouteProps {
    onlyRoot?: boolean;
    permission?: string;
}

function HasAccessRoute({ onlyRoot, permission }: HasAccessRouteProps) {

    const navigate = useNavigate();

    const { isAllowed } = useHasAccess({ onlyRoot, permission })

    useEffect(() => {
      if(isAllowed === false) {
        navigate('/404')
      }
    }, [isAllowed])
    

    return <Outlet />
}
export default HasAccessRoute